import { NAVIGATION_KEYS, SUB_NAVIGATION_KEYS } from "../../src/components/templates/Layout/NavBar/types"
import { SESSION_STATUS_ENUM } from "@antipartido-inc/contracts-ifaces"
import { WalletStatus } from "../../src/domain/ethereum/Models/WalletState"
import { TransactionType } from "../../src/domain/ethereum/Models/Transaction"

export default {
  kycStatus: {
    title: "Account status",
    options: {
      [SESSION_STATUS_ENUM.APPROVED]: "Verified",
      [SESSION_STATUS_ENUM.IN_REVIEW]: "In Review",
      [SESSION_STATUS_ENUM.NOT_STARTED]: "Not Started",
      [SESSION_STATUS_ENUM.IN_PROGRESS]: "In Progress",
      [SESSION_STATUS_ENUM.DECLINED]: "Declined",
      [SESSION_STATUS_ENUM.KYC_EXPIRED]: "Expired",
      [SESSION_STATUS_ENUM.EXPIRED]: "Expired",
      [SESSION_STATUS_ENUM.ABANDONED]: "Abandoned",
    },
  },
  walletStatus: {
    [WalletStatus.CONNECTED]: "Connected",
    [WalletStatus.DISCONNECTED]: "Disconnected",
  },
  navigation: {
    [NAVIGATION_KEYS.DASHBOARD]: {
      title: "Home",
      description: "Observe the general metrics of the {{projectToken}} token and DEX",
    },
    [NAVIGATION_KEYS.OPERATE]: {
      title: "Operate",
      description: "Start with the easiest: buy or get tokens in our DEX",
      tag: "New",
      items: {
        [SUB_NAVIGATION_KEYS.BUY]: {
          title: "Buy",
          description: "Buy {{projectToken}} tokens with card or bank transfer",
          tag: "New",
        },
        [SUB_NAVIGATION_KEYS.SWAP]: {
          title: "Swap",
          description: "Swap different tokens with each other at the best prices",
        },
      },
    },
    [NAVIGATION_KEYS.MORE]: {
      title: "More",
      items: {
        [SUB_NAVIGATION_KEYS.WALLET]: {
          title: "Wallet",
          description: "View your liquidity positions both in wallet and in contracts",
        },
        [SUB_NAVIGATION_KEYS.DOCS]: {
          title: "Docs",
          description: "Access our Whitepaper to understand the protocol in depth",
        },
        [SUB_NAVIGATION_KEYS.SETTINGS]: {
          title: "Settings",
          description: "Select Language, Currency and Light / Dark mode",
        },
      },
    },
  },
  modal: {
    error: {
      title: "Error",
      description: "An error occurred while processing your request.",
      sendToSupport: "Send to support",
      sending: "Sending...",
      reportId: "Report ID",
      reportIdDescription:
        "The report ID is used to track the error and will be sent to the support team. You can copy it and paste it into the telegram support channel to get help.",
      copyReportId: "Copy report ID",
      reportIdCopied: "Report ID copied to clipboard",
    },
  },
  newVersion: {
    message: "A new version is available. Please refresh the page to update.",
    reload: "Refresh",
  },

  advancedStaking: "Staking",
  back: "Back",
  logoAlt: "Antipartido Logo",
  stepProgress: "Step {{current}}/{{total}}: ",
  buy: "Buy",
  buyDescription: "Buy tokens with card or bank transfer",
  buyMobileDescription: "Buy {{projectToken}} tokens with your card or transfer",
  claim: "Claim",
  connect: "Connect",
  balance: "Balance",
  max: "Max",
  insufficientBalance: "Insufficient Balance",
  connectWallet: "Connect you wallet",
  contractAdress: "Contract Address",
  copy: "Copy",
  copied: "Copied",
  clean: "Clean",
  dashboard: "Home",
  dashboardDescription: "Observe the general metrics of the {{projectToken}} token and DEX",
  myVotings: "My Votings",
  profile: "My profile",
  error: "Error",
  operate: "Operate",
  operateDescription: "Start with the easiest part: buy or obtain tokens on our DEX",
  liquidity: "Liquidity",
  liquidityDescription: "Add liquidity and earn returns (APR).",
  liquidityMobileDescription: "Manage liquidity and earn incentives",
  prices: "Prices",
  rewards: "Rewards",
  pending: "Pending",
  settings: "Settings",
  settingsDescription: "Choose Language, Currency, and Light/Dark mode",
  swap: "Swap",
  swapDescription: "Exchange different tokens through an integrated swap",
  swapMobileDescription: "Exchange tokens at the best prices",
  token: "Token",
  sendToSupport: "Send to support",
  docs: "Docs",
  docsDescription: " Access our Whitepaper to gain an in-depth understanding of the protocol",
  more: "More",
  totalEarned: "Total Earned",
  address: "Address",
  quantity: "Quantity",
  send: "Send",
  noTransactions: "No recent movements.",
  disconnect: "Disconnect",
  yourAccount: "Your account",
  myHumanWallet: "My HumanWallet",
  switch_chain: "Switch Chain",
  walletAdd: "Add to wallet",
  tokensTitle: "{{projectToken}} Ecosystem Tokens",
  various: "Various",
  variousDescription: "Whitepaper, Guides to learn, settings and more",
  guides: "Guides",
  guidesDescription: "Learn how to operate in the DEX easily with our guides",
  transactions: {
    title: "Transactions",
    errorMessage: "The transaction could not be completed. Check the address or the balance of available tokens.",
    seeTransaction: "See transaction",
    types: {
      [TransactionType.VOTE]: "Thanks for your vote",
      [TransactionType.VOTE_EDIT]: "Thanks for your vote",
    },
    status: {
      PENDING: "Pending",
      SUCCESS: "Success",
      REVERTED: "Reverted",
    },
  },
  signature: {
    title: "Signature",
    errorMessage: "The signature could not be completed. Check the address or the balance of available tokens.",
    status: {
      PENDING: "Pending",
      SUCCESS: "Success",
      REVERTED: "Reverted",
    },
  },
  viewContract: "View contract",
  viewInExplorer: "View in explorer",
  view: "View",
  wallet: "Wallet",
  walletDescription: "View your liquidity positions both in your wallet and in contracts",
  walletMobileDescription: "View your positions in all DEX tokens",
  timeUnits: {
    second: "second",
    seconds: "seconds",
    minute: "minute",
    minutes: "minutes",
    hour: "hour",
    hours: "hours",
    day: "day",
    days: "days",
    week: "week",
    weeks: "weeks",
    month: "month",
    months: "months",
    year: "year",
    years: "years",
    yearFull: "1 year",
    yearsFull: "{{count}} years",
  },
  mint: "Mint",
  type: "Type",
  value: "Value",
  new: "New",
  updateVersion: "There is an update available, do you want to update?",
  other: "Other",
  totalDistributed: "Total distributed",
  dailyDistributed: "Today's distribution:",
  supply: {
    title: "Token Supply",
    max: "Max Supply",
    total: "Total Supply",
    circulating: "Circulating Supply",
    burned: "Burned",
    contracts: "Contracts",
  },
}
